const initialState = {
  defaultPrompts: {},
  chatMessages: {},
  currentPage: 1,
  loading: false,
  error: null,
  conversation: null,
  allConversations: [],
  allConversationsCurrentPage: 1,
  allConversationsTotalPages: 1,
  userMessageId: null,
  chatLoading: false,
  chatError: null,
  hasMoreMessages: true,
  scrollDirection: "append",
  conversationMessages: {},
  regenerateAiResponse: {},
  isNovaChatBotOpen: false,
  isNewConversation: false,
  isNovaGoalsAiEnabled: true,
  isNovaTeamsAiEnabled: true,
  disableHeaderOptions: false,
  isConversationChanged: false,
  updatedConversationId: null,
  updatedConversationTitle: null,
  notFromOtherUser: true,
  conversationLoadingStates: {},
  initialPrompt: null,
};

const GoalsCreateWithNovaAI = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_NOVA_CONVERSATION_STATE":
      return initialState;
    case "GET_NOVA_DEFAULT_PROMPTS_SUCCESS": {
      return {
        ...state,
        defaultPrompts: action.payload,
      };
    }
    case "CREATE_NOVA_CONVERSATION_REQUEST":
      return { ...state, loading: true, error: null };
    case "CREATE_NOVA_CONVERSATION_SUCCESS":
      return { ...state, loading: false, conversation: action.payload };
    case "CREATE_NOVA_CONVERSATION_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_NOVA_MESSAGES_REQUEST":
      return { ...state, loading: true, error: null };
    case "FETCH_NOVA_MESSAGES_SUCCESS": {
      const { messages, conversationId, append, hasMore, direction } =
        action.payload;
      const existingMessages = state.conversationMessages[conversationId] || [];

      let updatedMessages;
      if (append) {
        const existingIds = new Set(existingMessages.map((msg) => msg.id));
        const newMessages = messages.filter((msg) => !existingIds.has(msg.id));
        updatedMessages =
          direction === "prepend"
            ? [...newMessages, ...existingMessages]
            : [...existingMessages, ...newMessages];
      } else {
        updatedMessages = messages;
      }
      return {
        ...state,
        loading: false,
        chatMessages: {
          ...state.chatMessages,
          [conversationId]: updatedMessages,
        },
        conversationMessages: {
          ...state.conversationMessages,
          [conversationId]: updatedMessages,
        },
        hasMoreMessages: hasMore,
        scrollDirection: direction || "append",
      };
    }
    case "FETCH_NOVA_MESSAGES_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_ALL_NOVA_CONVERSATIONS_REQUEST":
      return { ...state, loading: true, error: null };
    case "FETCH_ALL_NOVA_CONVERSATIONS_SUCCESS": {
      const { nova_conversation, current_page, total_pages } = action.payload;

      const updatedConversations =
        current_page === 1
          ? nova_conversation
          : [...state.allConversations, ...nova_conversation];

      return {
        ...state,
        loading: false,
        allConversations: updatedConversations,
        allConversationsCurrentPage: current_page,
        allConversationsTotalPages: total_pages,
      };
    }

    case "FETCH_ALL_NOVA_CONVERSATIONS_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "SEND_NOVA_CHAT_MESSAGE_REQUEST":
      return { ...state, chatLoading: true, chatError: null };
    case "SEND_NOVA_CHAT_MESSAGE_SUCCESS": {
      const { conversationId, message } = action.payload;
      const list = state.conversationMessages[conversationId] || [];
      const updated = [...list, message];
      return {
        ...state,
        conversationMessages: {
          ...state.conversationMessages,
          [conversationId]: updated,
        },
        chatMessages: {
          ...state.chatMessages,
          [conversationId]: updated,
        },
      };
    }
    case "SEND_NOVA_CHAT_MESSAGE_FAILURE":
      return { ...state, chatLoading: false, chatError: action.payload };
    case "UPDATE_CONVERSATION_TITLE_SUCCESS": {
      const { conversationId, title } = action.payload;
      const updatedConversations = state.allConversations.map((conv) =>
        conv.id === conversationId ? { ...conv, name: title } : conv
      );

      return {
        ...state,
        allConversations: updatedConversations,
        conversation:
          state.conversation?.id === conversationId
            ? { ...state.conversation, name: title }
            : state.conversation,
        updatedConversationTitle: title,
      };
    }
    case "REGENERATE_NOVA_CHAT_MESSAGE_REQUEST":
      return { ...state, chatLoading: true, chatError: null };
    case "REGENERATE_NOVA_CHAT_MESSAGE_SUCCESS": {
      const { conversationId, message } = action.payload;
      const list = state.conversationMessages[conversationId] || [];
      const updated = [...list, message];
      return {
        ...state,
        conversationMessages: {
          ...state.conversationMessages,
          [conversationId]: updated,
        },
        chatMessages: {
          ...state.chatMessages,
          [conversationId]: updated,
        },
      };
    }
    case "REGENERATE_NOVA_CHAT_MESSAGE_FAILURE":
      return { ...state, chatLoading: false, chatError: action.payload };

    case "SEND_NOVA_CHAT_FEEDBACK_REQUEST":
      return { ...state, chatLoading: true, chatError: null };
    case "SEND_NOVA_CHAT_FEEDBACK_SUCCESS":
      return { ...state, chatLoading: false };
    case "SEND_NOVA_CHAT_FEEDBACK_FAILURE":
      return { ...state, chatLoading: false, chatError: action.payload };
    case "SET_USER_MESSAGE_ID":
      return {
        ...state,
        userMessageId: action.payload,
      };
    case "SET_AI_MESSAGE_ID":
      return {
        ...state,
        aiMessageId: action.payload,
      };
    case "GET_UPDATED_NOVA_CONVERSATION_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_UPDATED_NOVA_CONVERSATION_SUCCESS":
      return { ...state, chatLoading: false, conversation: action.payload };
    case "GET_UPDATED_NOVA_CONVERSATION_FAILURE":
      return { ...state, chatLoading: false, error: action.payload };
    case "SET_CONVERSATION_MESSAGES": {
      const { conversationId } = action.payload;
      const messages = state.conversationMessages[conversationId] || [];
      return {
        ...state,
        chatMessages: messages,
      };
    }
    case "CLEAR_CONVERSATION_MESSAGES":
      return {
        ...state,
        chatMessages: {},
        hasMoreMessages: true,
        currentPage: 1,
      };
    case "SET_REGENERATE_AI_RESPONSE":
      return {
        ...state,
        regenerateAiResponse: {
          ...state.regenerateAiResponse,
          [action.payload.conversationId]: action.payload.response,
        },
      };
    case "SET_IS_NOVA_CHATBOT_OPEN":
      return {
        ...state,
        isNovaChatBotOpen: action.payload,
      };
    case "SET_NEW_CONVERSATION":
      return {
        ...state,
        isNewConversation: action.payload,
      };
    case "SET_IS_GOALS_AI_ENABLED":
      return {
        ...state,
        isNovaGoalsAiEnabled: action.payload,
      };
    case "SET_IS_TEAMS_AI_ENABLED":
      return {
        ...state,
        isNovaTeamsAiEnabled: action.payload,
      };
    case "SET_DISABLE_HEADER_OPTIONS":
      return {
        ...state,
        disableHeaderOptions: action.payload,
      };
    case "SET_CHANGED_CONVERSTION": {
      const {
        isConversationChanged,
        updatedConversationId,
        updatedConversationTitle,
      } = action.payload;
      return {
        ...state,
        isConversationChanged: isConversationChanged,
        updatedConversationId: updatedConversationId,
        updatedConversationTitle: updatedConversationTitle,
      };
    }
    case "SET_CONVERSATION_LOADING": {
      const { conversationId, loading } = action.payload;
      return {
        ...state,
        conversationLoadingStates: {
          ...state.conversationLoadingStates,
          [conversationId]: {
            ...(state.conversationLoadingStates[conversationId] || {}),
            loading,
          },
        },
      };
    }
    case "SET_CONVERSATION_CHAT_LOADING": {
      const { conversationId, responseLoading } = action.payload;
      return {
        ...state,
        conversationLoadingStates: {
          ...state.conversationLoadingStates,
          [conversationId]: {
            ...(state.conversationLoadingStates[conversationId] || {}),
            responseLoading,
          },
        },
      };
    }
    case "LOAD_NOVA_CONVERSATION":
      return {
        ...state,
        conversation: action.payload, // load the conversation from localStorage for this employee
        messages: [], // you may also reset messages or keep a history per employee if needed
      };
    case "IS_NOT_FROM_IMPERSONATE_OR_SWITCHUSER":
      return {
        ...state,
        notFromOtherUser: action.payload,
      };
    case "SET_NOVA_INITIAL_PROMPT":
      return {
        ...state,
        initialPrompt: action.payload,
      };
    default:
      return state;
  }
};

export default GoalsCreateWithNovaAI;
